/* eslint-disable no-use-before-define, no-param-reassign */

import Component from '@bythepixel/component-loader';

export default class CheckboxSelect extends Component {
  static selector = '[data-comp-checkbox-select]';

  #selected = new Map();

  constructor(containerEl, options = {}) {
    super(containerEl, options);

    this.activator = containerEl.querySelector(
      '[data-comp-checkbox-select-activator]',
    );
    this.activatorTextEl = this.activator.firstElementChild;
    this.checkboxes = containerEl.querySelector(
      '[data-comp-checkbox-select-checkboxes]',
    );
    this.inputs = containerEl.querySelectorAll('input');

    this.originalFieldText = this.activatorTextEl.textContent;

    if (this.inputs.length === 0) {
      console.warn('CheckboxSelect | No input elements found; not mounting.');

      return;
    }

    this.mount();
  }

  toggleCheckboxes() {
    const isHidden = this.checkboxes.ariaHidden === 'true';

    this.checkboxes.ariaHidden = !isHidden;
    this.checkboxes.focus();
  }

  hideCheckboxes() {
    this.checkboxes.ariaHidden = true;
  }

  disable() {
    this.disabled = true;
  }

  enable() {
    this.disabled = false;
  }

  resetCheckboxes() {
    this.inputs.forEach((checkbox) => (checkbox.checked = false));
  }

  get hasSelection() {
    return this.$container.dataset.hasSelection === 'true';
  }

  set hasSelection(updatedValue) {
    this.$container.dataset.hasSelection = updatedValue;
  }

  findInput(inputIdAttribute) {
    const input = [...this.inputs].find(
      (_input) => _input.id === inputIdAttribute,
    );

    if (!input) {
      console.warn(
        `CheckboxSelect | Input with id ${inputIdAttribute} not found.`,
      );
      return null;
    }

    return input;
  }

  hideField(inputIdAttribute) {
    const input = this.findInput(inputIdAttribute);
    const label = input.parentElement;

    if (!label.classList.contains('tw-input__checkbox--hidden')) {
      label.classList.add('tw-input__checkbox--hidden');
    }

    input.disabled = true;
  }

  showField(inputIdAttribute) {
    const input = this.findInput(inputIdAttribute);
    const label = input.parentElement;

    label.classList.remove('tw-input__checkbox--hidden');
    input.disabled = false;
  }

  reset() {
    this.resetFieldText();
    this.resetCheckboxes();
  }

  handleInputChange() {
    const selectedInputs = [...this.inputs].filter((input) => input.checked);

    if (selectedInputs.length === 0) {
      this.resetFieldText();
      this.hasSelection = false;

      return;
    }

    this.hasSelection = true;
    this.updateSelected();
    this.updateFieldText();
  }

  updateSelected() {
    this.inputs.forEach((input) => {
      const mapKey = input.value;
      const isChecked = input.checked;

      if (!isChecked) {
        this.#selected.delete(mapKey);

        return;
      }

      this.#selected.set(mapKey, {
        element: input,
        label: input.parentElement,
      });
    });
  }

  resetFieldText() {
    this.activatorTextEl.textContent = this.originalFieldText;
  }

  updateFieldText() {
    const selectedInputs = this.#selected.values();

    const newText = [...selectedInputs].map((inputDetails) => inputDetails.label.textContent.trim());

    this.activatorTextEl.textContent = newText.join(', ');
  }

  attachListeners() {
    this.activator.addEventListener('click', () => {
      this.toggleCheckboxes();
    });

    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.handleInputChange();
      });
    });

    // Click outside listener for checkboxes dropdown
    window.addEventListener('click', (e) => {
      const checkboxesVisible = this.checkboxes.ariaHidden === 'false';

      if (!checkboxesVisible) {
        return;
      }

      const { target } = e;
      const targetIsActivator = target === this.activator || this.activator.contains(target);
      const targetInsideCheckboxes = target === this.checkboxes || this.checkboxes.contains(target);

      if (targetInsideCheckboxes || targetIsActivator) {
        return;
      }

      this.hideCheckboxes();
    });
  }

  mount() {
    this.attachListeners();
  }
}
